import { Link } from "react-router-dom";

export default function StartPage() {
  return (
    <>
      <div className="p-10 bg-cover bg-center  bg-[url('./diamondMain.jpg')] min-h-screen text-xl tracking-wide font-semibold">
        <div className=" w-screen  grid grid-cols-4 gap-4 p-10">
          <div className="flex flex-col gap-10 col-start-4">
            <Link to="/certifications">
              <p className=" text-white text-xl hover:underline">Zertifikate und Annerkungen</p>
            </Link>
            <Link to="/projects">
              <p className=" text-white text-xl hover:underline">Projekte und Fähigkeiten</p>
            </Link>
            <Link to="/information">
              <p className=" text-white text-xl hover:underline">Informationen über mich</p>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
